import { s as subscriptionsStoreName } from '../constants-4d9682b2.js';
export { s as subscriptionsStoreName } from '../constants-4d9682b2.js';
import { createSlice, createAction, combineReducers } from '@reduxjs/toolkit';
import { takeEvery, select, put, call, delay, all } from 'redux-saga/effects';
import { ISubscriptionStatus, PaymentMethodType as PaymentMethodType$1, api, ProviderType } from '@frontegg/rest-api';

function createModuleCaseReducers() {
    return {
        setLoading: {
            prepare: (payload) => ({ payload }),
            reducer: (state, action) => (Object.assign(Object.assign(Object.assign({}, state), { loading: action.payload }), (action.payload ? { error: null } : {}))),
        },
        setError: {
            prepare: (payload) => ({ payload }),
            reducer: (state, action) => (Object.assign(Object.assign({}, state), { error: action.payload, loading: false })),
        },
        setState: {
            prepare: (payload) => ({ payload }),
            reducer: (state, action) => (Object.assign(Object.assign({}, state), action.payload)),
        },
    };
}
function createKeyCaseReducer(key, setState) {
    return {
        prepare: (payload) => ({ payload }),
        reducer: (state, action) => (Object.assign(Object.assign({}, state), { [key]: setState(state[key], action) })),
    };
}
function createKeyCaseLoadingReducer(key) {
    return createKeyCaseReducer(key, (state, action) => (Object.assign(Object.assign({}, state), { loading: action.payload })));
}
function createKeyCaseErrorReducer(key) {
    return createKeyCaseReducer(key, (state, action) => (Object.assign(Object.assign({}, state), { error: action.payload, loading: false })));
}

const plansInitialState = {
    loading: false,
    error: null,
    plans: [],
};
const { actions: sliceActions$1, reducer: reducer$7, name: name$6 } = createSlice({
    name: `${subscriptionsStoreName}/plans`,
    initialState: plansInitialState,
    reducers: Object.assign(Object.assign({}, createModuleCaseReducers()), { setPlans: {
            prepare: (payload) => ({ payload }),
            reducer: (state, action) => (Object.assign(Object.assign({}, state), { plans: action.payload })),
        } }),
});
const actions$7 = Object.assign({ loadPlans: createAction(`${name$6}/loadPlans`) }, sliceActions$1);

const configInitialState = {
    loading: false,
    error: null,
    config: null,
};
const reducers$5 = Object.assign({}, createModuleCaseReducers());
const { actions: configActions, reducer: reducer$6, name: name$5 } = createSlice({
    name: `${subscriptionsStoreName}/config`,
    initialState: configInitialState,
    reducers: reducers$5,
});
const actions$6 = Object.assign({ loadPaymentConfiguration: createAction(`${name$5}/loadPaymentConfiguration`) }, configActions);

const initialBillingInformationState = {
    loading: false,
    error: null,
    externallyManaged: false,
    defaultPlanId: null,
    cancellation: {
        loading: false,
        error: null,
    },
    renewal: {
        loading: false,
        error: null,
    },
};
const reducers$4 = Object.assign(Object.assign({}, createModuleCaseReducers()), { setBillingInformation: {
        prepare: (payload) => ({ payload }),
        reducer: (state, action) => (Object.assign(Object.assign({}, state), action.payload)),
    }, setCancellationLoading: createKeyCaseLoadingReducer('cancellation'), setCancellationError: createKeyCaseErrorReducer('cancellation'), setRenewalLoading: createKeyCaseLoadingReducer('renewal'), setRenewalError: createKeyCaseErrorReducer('renewal') });
const { reducer: reducer$5, actions: overviewActions, name: name$4, } = createSlice({
    name: `${subscriptionsStoreName}/billing/information`,
    initialState: initialBillingInformationState,
    reducers: reducers$4,
});
const actions$5 = Object.assign({ loadBillingInformation: createAction(`${name$4}/loadBillingInformation`), cancelSubscription: createAction(`${name$4}/cancelSubscription`), renewSubscription: createAction(`${name$4}/renewSubscription`) }, overviewActions);

const initialPaymentMethodState = {
    loading: false,
    error: null,
};
const reducers$3 = Object.assign(Object.assign({}, createModuleCaseReducers()), { setState: {
        prepare: (payload) => ({ payload }),
        reducer: (state, action) => (Object.assign(Object.assign({}, state), action.payload)),
    } });
const { reducer: reducer$4, actions: paymentActions, name: name$3 } = createSlice({
    name: `${subscriptionsStoreName}/billing/payment`,
    initialState: initialPaymentMethodState,
    reducers: reducers$3,
});
const actions$4 = Object.assign({ loadPaymentMethod: createAction(`${name$3}/loadPaymentMethod`), submitPaymentMethod: createAction(`${name$3}/submitPaymentMethod`), submitPaymentMethodError: createAction(`${name$3}/submitPaymentMethodError`), submitPaymentMethodSuccess: createAction(`${name$3}/submitPaymentMethodSuccess`), updatePaymentMethodBillingDetails: createAction(`${name$3}/updateBillingDetails`, (payload) => ({ payload })) }, paymentActions);

const initialInvoicesState = {
    loading: false,
    error: null,
    invoices: [],
    invoiceDownload: {
        loading: false,
        error: null
    }
};
const reducers$2 = Object.assign(Object.assign({}, createModuleCaseReducers()), { setInvoices: {
        prepare: (payload) => ({ payload }),
        reducer: (state, action) => (Object.assign(Object.assign({}, state), { invoices: action.payload })),
    }, setInvoiceDownloadState: {
        prepare: (payload) => ({ payload }),
        reducer: (state, action) => (Object.assign(Object.assign({}, state), { invoiceDownload: Object.assign(Object.assign({}, state.invoiceDownload), action.payload) })),
    } });
const { reducer: reducer$3, actions: sliceActions, name: name$2, } = createSlice({
    name: `${subscriptionsStoreName}/billing/invoices`,
    initialState: initialInvoicesState,
    reducers: reducers$2,
});
const actions$3 = Object.assign({ loadInvoices: createAction(`${name$2}/loadInvoices`), downloadInvoice: createAction(`${name$2}/downloadInvoice`, (payload) => ({ payload })) }, sliceActions);

const billingInitialState = {
    information: initialBillingInformationState,
    invoices: initialInvoicesState,
    paymentMethod: initialPaymentMethodState,
};
const billingActions = {
    invoices: actions$3,
    information: actions$5,
    paymentMethod: actions$4,
};
const billingReducer = combineReducers({
    invoices: reducer$3,
    information: reducer$5,
    paymentMethod: reducer$4,
});

var CheckoutStatus;
(function (CheckoutStatus) {
    CheckoutStatus["SELECTION"] = "SELECTION";
    CheckoutStatus["CHECKOUT"] = "CHECKOUT";
    CheckoutStatus["CONFIRM"] = "CONFIRM";
    CheckoutStatus["ERROR"] = "ERROR";
    CheckoutStatus["CANCEL"] = "CANCEL";
})(CheckoutStatus || (CheckoutStatus = {}));
var CheckoutEvent;
(function (CheckoutEvent) {
    CheckoutEvent["SUBMITTED"] = "SUBMITTED";
    CheckoutEvent["ABORT"] = "ABORT";
    CheckoutEvent["CANCEL"] = "CANCEL";
    CheckoutEvent["ERROR"] = "ERROR";
    CheckoutEvent["CONFIRMED"] = "CONFIRMED";
})(CheckoutEvent || (CheckoutEvent = {}));

const checkoutInitialState = {
    loading: false,
    error: null,
    status: CheckoutStatus.SELECTION,
    checkoutPlanId: null,
};
const reducers$1 = Object.assign(Object.assign({}, createModuleCaseReducers()), { setStatus: {
        prepare: (payload) => ({ payload }),
        reducer: (state, action) => (Object.assign(Object.assign({}, state), { status: action.payload })),
    }, selectPlan: {
        prepare: (payload) => ({ payload }),
        reducer: (state, action) => (Object.assign(Object.assign({}, state), { checkoutPlanId: action.payload })),
    } });
const { actions: checkoutActions, reducer: reducer$2, name: name$1 } = createSlice({
    name: `${subscriptionsStoreName}/checkout`,
    initialState: checkoutInitialState,
    reducers: reducers$1,
});
const actions$2 = Object.assign({ checkoutPlan: createAction(`${name$1}/checkoutPlan`, (payload) => ({ payload })), resetCheckout: createAction(`${name$1}/resetCheckout`), confirmCheckout: createAction(`${name$1}/confirmCheckout`, (payload) => ({ payload, })), cancelCheckout: createAction(`${name$1}/cancelCheckout`), submitCheckout: createAction(`${name$1}/submitCheckout`), errorCheckout: createAction(`${name$1}/errorCheckout`, (payload) => ({ payload, })), checkoutEvent: createAction(`${name$1}/checkoutEvent`, (payload) => ({ payload, })) }, checkoutActions);

const initialSubscriptionStripeState = {
    loading: false,
    error: null,
    cardSetupIntentSecret: null,
};
const reducers = Object.assign(Object.assign({}, createModuleCaseReducers()), { setStripeState: {
        prepare: (payload) => ({ payload }),
        reducer: (state, action) => (Object.assign(Object.assign({}, state), action.payload)),
    } });
const { reducer: reducer$1, actions: reducerActions, name, } = createSlice({
    name: `${subscriptionsStoreName}/stripe`,
    initialState: initialSubscriptionStripeState,
    reducers,
});
const actions$1 = Object.assign({ loadCustomer: createAction(`${name}/loadCustomer`), createCardSetupIntentSecret: createAction(`${name}/createCardSetupIntentSecret`) }, reducerActions);

const initialState = {
    config: configInitialState,
    plans: plansInitialState,
    checkout: checkoutInitialState,
    billing: billingInitialState,
    stripe: initialSubscriptionStripeState,
};
const actions = {
    config: actions$6,
    billing: billingActions,
    plans: actions$7,
    checkout: actions$2,
    stripe: actions$1,
};
const reducer = combineReducers({
    config: reducer$6,
    billing: billingReducer,
    plans: reducer$7,
    checkout: reducer$2,
    stripe: reducer$1,
});

var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["STRIPE"] = "Stripe";
})(PaymentProvider || (PaymentProvider = {}));
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["ACTIVE"] = "ACTIVE";
    SubscriptionStatus["CANCELED"] = "CANCELED";
    SubscriptionStatus["INCOMPLETE"] = "INCOMPLETE";
    SubscriptionStatus["EXPIRED"] = "EXPIRED";
})(SubscriptionStatus || (SubscriptionStatus = {}));
var SubscriptionCancellationPolicy;
(function (SubscriptionCancellationPolicy) {
    SubscriptionCancellationPolicy["AT_PERIOD_END"] = "atPeriodEnd";
})(SubscriptionCancellationPolicy || (SubscriptionCancellationPolicy = {}));

function toPrice(amount) {
    return +(amount / 100).toFixed(2);
}
function toSubscriptionCancellation({ policy }) {
    return {
        policy: toSubscriptionCancellationPolicy(),
    };
}
function toSubscriptionCancellationPolicy(policy) {
    return SubscriptionCancellationPolicy.AT_PERIOD_END;
}
function toSubscriptionStatus(status) {
    switch (status) {
        case ISubscriptionStatus.ACTIVE:
            return SubscriptionStatus.ACTIVE;
        case ISubscriptionStatus.INCOMPLETE:
            return SubscriptionStatus.INCOMPLETE;
        case ISubscriptionStatus.CANCELED:
            return SubscriptionStatus.CANCELED;
        case ISubscriptionStatus.EXPIRED:
            return SubscriptionStatus.EXPIRED;
        default:
            return SubscriptionStatus.EXPIRED;
    }
}

const subscriptionResponseMock = {
    id: 'sub_1JbhYVEwsu4qiqnnfMhYAdY6',
    externalId: 'sub_1JbhYVEwsu4qiqnnfMhYAdY6',
    startDate: '2021-09-20T08:08:51.000Z',
    status: ISubscriptionStatus.ACTIVE,
    cancellation: null,
    currentPeriodStart: '2021-09-20T08:08:51.000Z',
    currentPeriodEnd: '2021-10-20T08:08:51.000Z',
    items: [
        {
            id: 'si_KGE0p5himocPXH',
            externalId: 'prod_J60fUEvI7qV1eL',
            planId: 'prod_J60fUEvI7qV1eL',
            price: {
                id: 'price_1IToe8Ewsu4qiqnndAV76J69',
                externalId: 'price_1IToe8Ewsu4qiqnndAV76J69',
                currency: 'usd',
                amount: 10000,
            },
        },
    ],
};
const planResponseMock = [
    {
        id: 'prod_J60fUEvI7qV1eL',
        externalId: 'prod_J60fUEvI7qV1eL',
        name: 'Premium',
        description: '',
        price: {
            id: 'price_1IToe8Ewsu4qiqnndAV76J69',
            externalId: 'price_1IToe8Ewsu4qiqnndAV76J69',
            currency: 'usd',
            amount: 10000,
        },
    },
    {
        id: 'prod_J60duauCpXfcur',
        externalId: 'prod_J60duauCpXfcur',
        name: 'Free',
        description: 'Totally free plan. Nothing to pay.',
        price: {
            id: 'price_1ITocfEwsu4qiqnnnBHDx9fQ',
            externalId: 'price_1ITocfEwsu4qiqnnnBHDx9fQ',
            currency: 'usd',
            amount: 0,
        },
    },
];
const invoicesMock = [
    {
        id: 'in_1JbhYWEwsu4qiqnnrUh6hsHa',
        externalId: 'in_1JbhYWEwsu4qiqnnrUh6hsHa',
        subscriptionId: 'sub_1JbhYVEwsu4qiqnnfMhYAdY6',
        paymentDate: '2021-09-20T08:08:51.000Z',
        totalAmount: 10000,
        currency: 'usd',
        paid: true,
        receiptNumber: '',
    },
    {
        id: 'in_1JbhYWEwsu4qiqnnrUh6hsHa',
        externalId: 'in_1JbhYWEwsu4qiqnnrUh6hsHa',
        subscriptionId: 'sub_1JbhYVEwsu4qiqnnfMhYAdY6',
        paymentDate: '2021-08-20T08:08:51.000Z',
        totalAmount: 10000,
        currency: 'usd',
        paid: true,
        receiptNumber: '',
    },
];
const paymentMethodsMock = [
    {
        id: 'id',
        externalId: 'externalId',
        type: PaymentMethodType$1.CARD,
        isDefault: true,
        last4: '4242',
        expMonth: 11,
        expYear: 25,
        brand: 'visa',
        billingDetails: {
            name: 'Dummy',
            email: 'dummy@email.com',
        }
    }
];

function* subscriptionBillingInformationSagas() {
    yield takeEvery(actions$5.loadBillingInformation, loadBillingInformation);
    yield takeEvery(actions$5.cancelSubscription, cancelSubscription);
    yield takeEvery(actions$5.renewSubscription, renewSubscription);
    yield takeEvery(actions$2.checkoutEvent, checkoutEvent$2);
}
function* loadBillingInformation() {
    const paymentProvider = yield select((state) => { var _a; return (_a = state.subscriptions.config.config) === null || _a === void 0 ? void 0 : _a.paymentProvider; });
    const tenantId = yield select((state) => { var _a, _b, _c; return (_c = (_b = (_a = state.auth) === null || _a === void 0 ? void 0 : _a.profileState) === null || _b === void 0 ? void 0 : _b.profile) === null || _c === void 0 ? void 0 : _c.tenantId; });
    yield put(actions$5.setLoading(true));
    if (!paymentProvider || !tenantId) {
        yield put(actions$5.setError(!paymentProvider ? 'Internal feature failure' : 'Not authorized'));
        return;
    }
    try {
        yield loadSummaries(tenantId);
    }
    catch (e) {
        yield put(actions$5.setError(e.message));
    }
}
function* loadSummaries(tenantId) {
    var _a, _b;
    yield put(actions$5.setLoading(true));
    try {
        const { currentPlanId, subscriptionId, externallyManaged, defaultPlanId } = yield call(api.subscriptions.getSubscriptionSummaries, tenantId);
        const subscriptionResponse = yield call(api.subscriptions.getSubscription, subscriptionId);
        const planResponse = yield call(api.subscriptions.getSubscriptionPlan, currentPlanId);
        yield put(actions$5.setBillingInformation(Object.assign(Object.assign({ loading: false, externallyManaged,
            defaultPlanId }, (subscriptionResponse
            ? {
                subscription: {
                    id: subscriptionResponse.id,
                    externalId: subscriptionResponse.externalId,
                    startDate: new Date(subscriptionResponse.startDate),
                    currentPeriodStart: new Date(subscriptionResponse.currentPeriodStart),
                    currentPeriodEnd: new Date(subscriptionResponse.currentPeriodEnd),
                    status: toSubscriptionStatus(subscriptionResponse.status),
                    cancellation: subscriptionResponse.cancellation && toSubscriptionCancellation(subscriptionResponse.cancellation),
                    items: subscriptionResponse.items.map((subscriptionItem) => ({
                        id: subscriptionItem.id,
                        planId: subscriptionItem.planId,
                    })),
                },
            }
            : {})), (planResponse
            ? {
                plan: {
                    id: planResponse.id,
                    name: planResponse.name,
                    description: planResponse.description,
                    price: toPrice(((_a = planResponse.price) === null || _a === void 0 ? void 0 : _a.amount) || 0),
                    currency: ((_b = planResponse.price) === null || _b === void 0 ? void 0 : _b.currency) || 'usd',
                    recurringInterval: 'month',
                },
            }
            : {}))));
    }
    catch (e) {
        yield put(actions$5.setError(e.message));
    }
}
function* cancelSubscription() {
    const overview = yield select((state) => state.subscriptions.billing.information);
    if (!overview.subscription) {
        return;
    }
    if (overview.externallyManaged) {
        yield put(actions$5.setCancellationError('Billing is externally managed'));
        return;
    }
    const { id: subscriptionId, cancellation, status } = overview.subscription || {};
    const isCancellable = !cancellation && status === SubscriptionStatus.ACTIVE;
    if (isCancellable) {
        try {
            yield put(actions$5.setCancellationLoading(true));
            yield call(api.subscriptions.cancelSubscription, subscriptionId);
            yield put(actions$5.setBillingInformation({
                subscription: Object.assign(Object.assign({}, overview.subscription), { cancellation: {
                        policy: SubscriptionCancellationPolicy.AT_PERIOD_END,
                    } }),
            }));
            yield put(actions$5.setCancellationLoading(false));
        }
        catch (e) {
            yield put(actions$5.setCancellationError(e.message));
        }
    }
}
function* renewSubscription() {
    const overview = yield select((state) => state.subscriptions.billing.information);
    if (!overview.subscription) {
        return;
    }
    if (overview.externallyManaged) {
        yield put(actions$5.setCancellationError('Billing is externally managed'));
        return;
    }
    const { id: subscriptionId, cancellation } = overview.subscription || {};
    const renewable = (cancellation === null || cancellation === void 0 ? void 0 : cancellation.policy) === SubscriptionCancellationPolicy.AT_PERIOD_END;
    if (renewable) {
        try {
            yield put(actions$5.setRenewalLoading(true));
            yield call(api.subscriptions.renewSubscription, subscriptionId);
            yield put(actions$5.setBillingInformation({
                subscription: Object.assign(Object.assign({}, overview.subscription), { cancellation: null }),
            }));
            yield put(actions$5.setRenewalLoading(false));
        }
        catch (e) {
            yield put(actions$5.setCancellationError(e.message));
        }
    }
}
function* checkoutEvent$2({ payload }) {
    if (payload === CheckoutEvent.CONFIRMED) {
        yield loadBillingInformation();
    }
}
/*********************************
 *  Preview Sagas
 *********************************/
function* loadBillingInformationMock() {
    yield put(actions$5.setLoading(true));
    yield loadSummariesMock();
}
function* loadSummariesMock() {
    var _a, _b;
    yield put(actions$5.setLoading(true));
    yield delay(500);
    yield put(actions$5.setBillingInformation({
        loading: false,
        externallyManaged: false,
        subscription: Object.assign(Object.assign({}, subscriptionResponseMock), { startDate: new Date(subscriptionResponseMock.startDate), currentPeriodStart: new Date(subscriptionResponseMock.currentPeriodStart), currentPeriodEnd: new Date(subscriptionResponseMock.currentPeriodEnd), status: toSubscriptionStatus(subscriptionResponseMock.status), cancellation: subscriptionResponseMock.cancellation && toSubscriptionCancellation(subscriptionResponseMock.cancellation), items: subscriptionResponseMock.items }),
        plan: Object.assign(Object.assign({}, planResponseMock[0]), { price: toPrice((_a = planResponseMock[0].price) === null || _a === void 0 ? void 0 : _a.amount), currency: (_b = planResponseMock[0].price) === null || _b === void 0 ? void 0 : _b.currency, recurringInterval: 'month' }),
    }));
}
function* subscriptionBillingInformationSagasMock() {
    yield takeEvery(actions$5.loadBillingInformation, loadBillingInformationMock);
}

function* subscriptionsPaymentMethodSagas() {
    yield takeEvery(actions$4.loadPaymentMethod, loadPaymentMethod);
    yield takeEvery(actions$4.submitPaymentMethod, submitPaymentMethod);
    yield takeEvery(actions$4.submitPaymentMethodError, submitPaymentMethodError);
    yield takeEvery(actions$4.submitPaymentMethodSuccess, submitPaymentMethodSuccess);
    yield takeEvery(actions$4.updatePaymentMethodBillingDetails, updateBillingDetails);
    yield takeEvery(actions$2.checkoutEvent, checkoutEvent$1);
}
function* loadPaymentMethod() {
    yield put(actions$4.setLoading(true));
    try {
        const paymentMethods = yield call(api.subscriptions.getPaymentMethods);
        const paymentMethod = paymentMethods[0];
        if (paymentMethod) {
            yield put(actions$4.setState({
                paymentMethod,
                loading: false,
            }));
        }
        else {
            yield put(actions$4.setLoading(false));
        }
    }
    catch (e) {
        yield put(actions$4.setError(e.message));
    }
}
function* checkoutEvent$1({ payload }) {
    if (payload === CheckoutEvent.CONFIRMED) {
        yield loadPaymentMethod();
    }
}
function* updateBillingDetails({ payload, }) {
    yield put(actions$4.setLoading(true));
    const { id, email, address, callback } = payload;
    try {
        yield call(api.subscriptions.updatePaymentMethodBillingDetails, id, Object.assign({ email }, address));
        yield call(loadPaymentMethod);
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(actions$4.setError(e.message));
        callback === null || callback === void 0 ? void 0 : callback(false);
    }
    yield put(actions$4.setLoading(false));
}
function* submitPaymentMethod() {
    yield put(actions$4.setLoading(true));
}
function* submitPaymentMethodError({ payload: error }) {
    yield put(actions$4.setError(error));
}
function* submitPaymentMethodSuccess() {
    yield put(actions$4.loadPaymentMethod());
}
/*********************************
 *  Preview Sagas
 *********************************/
function* loadPaymentMethodMock() {
    yield put(actions$4.setLoading(true));
    yield delay(500);
    const paymentMethod = paymentMethodsMock[0];
    yield put(actions$4.setState({
        paymentMethod,
        loading: false,
    }));
}
function* subscriptionsPaymentMethodSagasMock() {
    yield takeEvery(actions$4.loadPaymentMethod, loadPaymentMethodMock);
}

function* subscriptionInvoicesSagas() {
    yield takeEvery(actions$3.loadInvoices, loadInvoices);
    yield takeEvery(actions$3.downloadInvoice, downloadInvoice);
    yield takeEvery(actions$2.checkoutEvent, checkoutEvent);
}
function* loadInvoices() {
    yield put(actions$3.setLoading(true));
    try {
        const invoices = yield call(api.subscriptions.getSubscriptionInvoices);
        yield put(actions$3.setState({
            invoices: invoices.map((invoice) => ({
                id: invoice.id,
                externalId: invoice.externalId,
                subscriptionId: invoice.subscriptionId,
                paymentDate: new Date(Date.parse(invoice.paymentDate)),
                totalAmount: +((invoice.totalAmount || 0) / 100).toFixed(2),
                currency: invoice.currency || 'usd',
                paid: invoice.paid || false,
                receiptNumber: invoice.receiptNumber,
            })),
        }));
        yield put(actions$3.setLoading(false));
    }
    catch (e) {
        yield put(actions$3.setError(e.message));
    }
}
function* downloadInvoice({ payload }) {
    yield put(actions$3.setInvoiceDownloadState({ loading: true, error: null }));
    try {
        yield call(api.subscriptions.getSubscriptionInvoicePdf, payload.invoiceId, payload.filename);
        yield put(actions$3.setInvoiceDownloadState({ loading: false, error: null }));
    }
    catch (e) {
        yield put(actions$3.setInvoiceDownloadState({ loading: false, error: e.message || null }));
    }
}
function* checkoutEvent({ payload }) {
    if (payload === CheckoutEvent.CONFIRMED) {
        yield loadInvoices();
    }
}
/*********************************
 *  Preview Sagas
 *********************************/
function* loadInvoicesMock() {
    yield put(actions$3.setLoading(true));
    yield delay(500);
    const selectPlanTitle = 'Premium';
    yield put(actions$3.setInvoices(invoicesMock.map((invoice) => (Object.assign(Object.assign({}, invoice), { selectedPlan: selectPlanTitle, paymentDate: new Date(Date.parse(invoice.paymentDate)), totalAmount: +((invoice.totalAmount || 0) / 100).toFixed(2) })))));
    yield put(actions$3.setLoading(false));
}
function* subscriptionInvoicesSagasMock() {
    yield takeEvery(actions$3.loadInvoices, loadInvoicesMock);
}

function* billingSagas() {
    yield all([
        call(subscriptionBillingInformationSagas),
        call(subscriptionsPaymentMethodSagas),
        call(subscriptionInvoicesSagas),
    ]);
}
function* billingSagasMock() {
    yield all([
        call(subscriptionBillingInformationSagasMock),
        call(subscriptionsPaymentMethodSagasMock),
        call(subscriptionInvoicesSagasMock),
    ]);
}

function* checkoutSagas() {
    yield takeEvery(actions$2.checkoutPlan, checkoutPlan);
    yield takeEvery(actions$2.resetCheckout, resetCheckout);
    yield takeEvery(actions$2.confirmCheckout, confirmPlan);
    yield takeEvery(actions$2.cancelCheckout, cancelPlan);
    yield takeEvery(actions$2.submitCheckout, submitCheckout);
    yield takeEvery(actions$2.errorCheckout, errorCheckout);
}
function* checkoutPlan({ payload: planId }) {
    yield put(actions$2.setState({
        checkoutPlanId: planId,
        loading: false,
        error: null,
        status: CheckoutStatus.CHECKOUT,
    }));
}
function* resetCheckout() {
    yield put(actions$2.setState({
        checkoutPlanId: null,
        loading: false,
        status: CheckoutStatus.SELECTION,
    }));
}
function* confirmPlan({ payload: paymentMethodId }) {
    var _a;
    const { subscription, status, checkoutPlanId } = yield select(({ subscriptions: { billing: { information }, checkout, }, }) => ({
        subscription: information.subscription,
        status: checkout.status,
        checkoutPlanId: checkout.checkoutPlanId,
    }));
    const subscriptionId = subscription === null || subscription === void 0 ? void 0 : subscription.id;
    const subscriptionItemId = (_a = subscription === null || subscription === void 0 ? void 0 : subscription.items[0]) === null || _a === void 0 ? void 0 : _a.id;
    if (!checkoutPlanId || !subscriptionId || !subscriptionItemId) {
        yield put(actions$2.setState({
            loading: false,
            status: CheckoutStatus.ERROR,
        }));
        return;
    }
    if (status === CheckoutStatus.CHECKOUT) {
        yield put(actions$2.setState({
            loading: true,
            error: null,
        }));
        try {
            yield call(api.subscriptions.updateSubscription, subscriptionId, {
                paymentMethodId,
                items: [
                    {
                        id: subscriptionItemId,
                        planId: checkoutPlanId,
                    },
                ],
            });
            yield put(actions$2.setState({
                checkoutPlanId: null,
                loading: false,
                status: CheckoutStatus.CONFIRM,
            }));
            yield put(actions$2.checkoutEvent(CheckoutEvent.CONFIRMED));
        }
        catch (e) {
            yield put(actions$2.setState({
                loading: false,
                error: e.message,
                status: CheckoutStatus.ERROR,
            }));
            yield put(actions$2.checkoutEvent(CheckoutEvent.ERROR));
        }
    }
}
function* cancelPlan() {
    const { status } = yield select((state) => state.subscriptions.checkout);
    if (status === CheckoutStatus.CHECKOUT) {
        yield put(actions$2.setState({
            checkoutPlanId: null,
            loading: false,
            error: null,
            status: CheckoutStatus.CANCEL,
        }));
        yield put(actions$2.checkoutEvent(CheckoutEvent.CANCEL));
    }
}
/**
 * Based on payment provider type
 */
function* submitCheckout() {
    const { paymentProvider } = yield select((state) => state.subscriptions.config.config);
    if (paymentProvider === PaymentProvider.STRIPE) {
        yield put(actions$2.setState({
            loading: true,
            error: null,
        }));
        yield put(actions$2.checkoutEvent(CheckoutEvent.SUBMITTED));
    }
}
function* errorCheckout({ payload }) {
    yield put(actions$2.setState({
        loading: false,
        error: payload,
        status: CheckoutStatus.ERROR,
    }));
    yield put(actions$2.checkoutEvent(CheckoutEvent.ERROR));
}
/*********************************
 *  Preview Sagas
 *********************************/
function* checkoutSagasMock() {
    yield takeEvery(actions$2.checkoutPlan, checkoutPlan);
    yield takeEvery(actions$2.resetCheckout, resetCheckout);
    yield takeEvery(actions$2.cancelCheckout, cancelPlan);
}

function* plansSagas() {
    yield takeEvery(actions$7.loadPlans, loadPlans);
}
function* loadPlans() {
    yield put(actions$7.setLoading(true));
    try {
        const products = yield call(api.subscriptions.getSubscriptionPlans);
        yield put(actions$7.setPlans(products.map((item) => {
            var _a, _b;
            return ({
                id: item.id,
                name: item.name,
                description: item.description,
                price: +((((_a = item.price) === null || _a === void 0 ? void 0 : _a.amount) || 0) / 100).toFixed(2),
                currency: ((_b = item.price) === null || _b === void 0 ? void 0 : _b.currency) || 'usd',
                recurringInterval: 'month',
            });
        })));
        yield put(actions$7.setLoading(false));
    }
    catch (e) {
        yield put(actions$7.setError(e.message));
    }
}
/*********************************
 *  Preview Sagas
 *********************************/
function* loadPlansMock() {
    yield put(actions$7.setLoading(true));
    yield delay(500);
    yield put(actions$7.setPlans(planResponseMock.map((item) => {
        var _a, _b;
        return (Object.assign(Object.assign({}, item), { price: +((((_a = item.price) === null || _a === void 0 ? void 0 : _a.amount) || 0) / 100).toFixed(2), currency: ((_b = item.price) === null || _b === void 0 ? void 0 : _b.currency) || 'usd', recurringInterval: 'month' }));
    })));
    yield put(actions$7.setLoading(false));
}
function* plansSagasMock() {
    yield takeEvery(actions$7.loadPlans, loadPlansMock);
}

var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["UNKNWON"] = "unknown";
    PaymentMethodType["CARD"] = "card";
})(PaymentMethodType || (PaymentMethodType = {}));

function* configSagas() {
    yield takeEvery(actions$6.loadPaymentConfiguration, loadPaymentConfiguration);
}
function* loadPaymentConfiguration() {
    yield put(actions$6.setLoading(true));
    try {
        const response = yield call(api.subscriptions.getPaymentProviders) || [];
        const stripePaymentProvider = response.find((paymentProvider) => paymentProvider.status === '1' && paymentProvider.providerType === ProviderType.Stripe);
        if (stripePaymentProvider) {
            yield loadStripePaymentConfiguration();
        }
        else {
            yield put(actions$6.setError('Payment provider not configured'));
        }
    }
    catch (e) {
        yield put(actions$6.setError(e.message));
    }
}
function* loadStripePaymentConfiguration() {
    yield put(actions$6.setLoading(true));
    try {
        const response = yield call(api.subscriptions.getStripePaymentProviderConfiguration);
        yield put(actions$6.setState({
            loading: false,
            config: {
                paymentProvider: PaymentProvider.STRIPE,
                apiKey: response.publishableKey
            }
        }));
    }
    catch (e) {
        yield put(actions$6.setError(e.message));
    }
}
/*********************************
 *  Preview Sagas
 *********************************/
function* loadPaymentConfigurationMock() {
    yield put(actions$6.setLoading(true));
    yield delay(500);
    yield put(actions$6.setState({
        loading: false,
        config: {
            paymentProvider: PaymentProvider.STRIPE,
            apiKey: ''
        },
    }));
}
function* configSagasMock() {
    yield takeEvery(actions$6.loadPaymentConfiguration, loadPaymentConfigurationMock);
}

function* subscriptionStripeSagas() {
    yield takeEvery(actions$1.createCardSetupIntentSecret, createCardSetupIntentSecret);
}
function* createCardSetupIntentSecret({ payload }) {
    yield put(actions$1.setStripeState({
        loading: true,
        error: null,
        cardSetupIntentSecret: null
    }));
    try {
        const { setupIntentSecret } = yield call(api.subscriptions.createStripePaymentMethodSetupIntentSecret, {
            paymentMethodId: payload || undefined
        });
        yield put(actions$1.setStripeState({
            cardSetupIntentSecret: setupIntentSecret,
            loading: false
        }));
    }
    catch (e) {
        yield put(actions$1.setError(e.message));
    }
}

function* sagas() {
    yield all([call(billingSagas), call(checkoutSagas), call(plansSagas), call(configSagas), call(subscriptionStripeSagas)]);
}
function* mockSagas() {
    yield all([call(billingSagasMock), call(checkoutSagasMock), call(plansSagasMock), call(configSagasMock)]);
}

// export store
// export store
var subscriptionsStore = {
    sagas,
    mockSagas,
    reducer,
    actions,
    initialState,
    storeName: subscriptionsStoreName,
};

export { CheckoutEvent, CheckoutStatus, PaymentMethodType, PaymentProvider, SubscriptionCancellationPolicy, SubscriptionStatus, subscriptionsStore as default, actions as subscriptionActions, initialState as subscriptionInitialState, reducer as subscriptionReducers, sagas as subscriptionSagas, mockSagas as subscriptionSagasMock };
